import type { OpenQuestionAnswerEntry } from '../../../../reducers/student/tracking/openQuestionAnswersReducer';
import type { TrackingIdentifier } from '@ael/core-api';

export const InteractionId = {
  encode: (item: TrackingIdentifier, widget: TrackingIdentifier): string => `${item}:${widget}`,
  decode: (raw: string): readonly [TrackingIdentifier, TrackingIdentifier] | null => {
    const separatorIndex = raw.indexOf(':');
    return separatorIndex === -1
      ? null
      : [raw.slice(0, separatorIndex) as TrackingIdentifier, raw.slice(separatorIndex + 1) as TrackingIdentifier];
  },
};

export const InteractionResponse = {
  encode: ({ questionText, answer }: OpenQuestionAnswerEntry): string => JSON.stringify({ q: questionText, a: answer }),
  decode: (raw: string): OpenQuestionAnswerEntry => {
    const parsed = JSON.parse(raw) as { q?: string; a?: string };
    return { questionText: parsed.q ?? '', answer: parsed.a ?? '' };
  },
};
